import React, { useContext, useState } from 'react'
import './homepage.styles.css'
import '../../routes/other-styles.styles.css'
import homeBg from '../../assets/spoude_home.jpg'
import vector2 from '../../assets/spoude-vector-02.png'
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2'
import { BsCart4 } from 'react-icons/bs'
import { LiaFileInvoiceDollarSolid } from 'react-icons/lia'
import { UserContext } from '../../context/user.context' 
import { Button } from '@material-tailwind/react'
import { Link } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
// import { OTPGen } from '../../utils/firebase/firebase.utils'

const Homepage = () => {
  const { company } = useContext(UserContext);
  const [ newComp, setNewComp ] = useState(company);
  const { currentUser, setCurrentUser } = useAuth();
  // const { companyDisplayName, companyName, slogan, address1, address2, phone, email, country, logo } = formFields;
  // console.log(company)

  // useState(() => {
    // if (company !== null) {
    //   // console.log(company)
    //   setNewComp(company)
    // }
    // setTimeout(() => {
    //   console.log(company)
    //   setNewComp(company)
    // }, 3000);
    // OTPGen(100)
  //   console.log('OTP generatin done..!')
  // }, []);

  return (
    <div className='home-container'>
      {/* {company ?
      <p>{company.companyName}</p>
      :null} */}
      <div className='spoude'>
        {company ? 
          <>
            <img className='w-16 mx-[calc((100%-64px)/2)]' src={company.logo} alt="" />
            <h2>{company.companyDisplayName}</h2> 
              <h4>{company.slogan}</h4>
          </>
        :
          <>
            {/* <img className='w-16 mx-[calc((100%-64px)/2)]' src="https://firebasestorage.googleapis.com/v0/b/sproude-pos.appspot.com/o/files%2Fec1084bc-1792-4b0a-85ad-feb6a35f7f60?alt=media&token=72532b5b-b67e-4e07-968a-b2a7a41eef61" alt="" /> */}
            <h2>PivoApps</h2> 
            <h4>Start by creating a</h4>
          </>
        }
        {/* { currentUser ? null
        : */}
          <Link to="/events"><Button type='button' className='m-2'>New Event</Button></Link>
        {/* } */}
      </div>
      <div className='pivoapps'>
        <img src="https://firebasestorage.googleapis.com/v0/b/sproude-pos.appspot.com/o/files%2Fec1084bc-1792-4b0a-85ad-feb6a35f7f60?alt=media&token=72532b5b-b67e-4e07-968a-b2a7a41eef61" alt="" />
        <h4>PivoApps Consults</h4>
      </div>
    </div>
  )
}

export default Homepage